module.exports = __webpack_public_path__ + "media/assets/images/otoiawase-img-ebc931f2f0b468e0e767f28df7e15a05.png";